import { TextField } from "@mui/material"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"

export const PopperTextInput = styled(TextField)<{ $lightMode?: boolean; $minHeight?: string }>`
  width: 100%;
  position: relative;

  label:not(.Mui-error),
  label.Mui-focused:not(.Mui-error) {
    color: ${(p) => p.theme.primaryColor};
  }

  .MuiOutlinedInput-input {
    padding-right: 75px;
    min-height: ${(p) => (p.$minHeight ? css`calc(${p.$minHeight} - 15px)` : "")};
  }

  & .MuiOutlinedInput-root {
    color: ${(p) => p.theme.textColor};

    &:not(.Mui-error) {
      &.Mui-focused fieldset {
        color: ${(p) => p.theme.primaryColor};
        border-color: ${(p) => p.theme.primaryColor};
      }

      & input,
      & fieldset,
      &:hover fieldset {
        border-color: ${(p) => p.theme.primaryColor};
      }
    }
  }

  ${(p) =>
    !p.$lightMode &&
    css`
      & .MuiFormHelperText-root:not(.Mui-error) {
        color: ${theme.color.white};
      }
    `}
`
